module.exports = __webpack_public_path__ + "static/media/physics_explain.02b76adc.jpg";